<template>
    <div class="row">
        <div class="col-lg-12 m-b-20 client-blacklist-title">
            <h3>Client Black List Data</h3>
        </div>
        <div class="col-lg-8">
            <b-form v-if="status == 'completed'">
                <base-upload-file
                    :checked-val="checked"
                    :column-config="labels"
                    type="import"
                    :upload-file-css="uploadFileCss"
                    :import-custom-file="importCustomFile"
                    :accept-file="acceptFile"
                    :label-val="'UPLOAD FILES'"
                    @show-progress="showProgress"
                >
                    <slot>
                        <div class="file-detail">
                            <div class="file-title">
                                <h5>
                                    Click here or drag &amp; drop data file here
                                    to upload
                                </h5>
                                <p>Supported file formats are XLS and XLSX</p>
                            </div>
                        </div>
                    </slot>
                </base-upload-file>
                <!-- <b-form-file
                    v-model="form.file"
                    :state="Boolean(form.file)"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                ></b-form-file> -->

                <base-toast></base-toast>
                <div class="file-activity">
                    <div class="file-thumbnail">
                        <excel-icon></excel-icon>
                    </div>
                    <div class="file-progress">
                        <h6>Uploading</h6>
                        <b-progress
                            :value="progressValue"
                            :max="max"
                            class="mb-3"
                        ></b-progress>
                        <span>{{ progressValue }}% completed</span>
                    </div>
                </div>

                <div class="file-upload-info">
                    <div class="file-last-update">
                        <p>
                            Last updated on
                            <span>{{
                                updated_date ? updated_date : 'Not updated'
                            }}</span>
                        </p>
                    </div>
                    <div
                        v-if="updated_date && downloadClientList"
                        class="download-current-file"
                    >
                        <button
                            class="btn btn-link"
                            @click.prevent="startDownload()"
                        >
                            <i class="icon-export"></i>

                            <span class="btn-text"
                                >Download Current Data File</span
                            >
                        </button>
                    </div>
                </div>
            </b-form>
            <div v-if="status == 'in-process'" class="upload-files h-100px">
                <div class="file-detail">
                    <div class="file-title">
                        <h5 class="m-b-0px">
                            File in process, you can't upload the file.
                        </h5>
                    </div>
                </div>
            </div>
            <!-- When data is loading -->
            <base-table-spinner v-if="showPageLoader"></base-table-spinner>
        </div>

        <div class="col-lg-4">
            <div class="download-template">
                <h5>Download Template</h5>
                <p>
                    To upload your proprietary sanction list into the system,
                    please download the template file. This will help you
                    understand the fields required. You can transform your list
                    accordingly and upload it back into the system.
                </p>
                <div class="link-action">
                    <div class="file-thumbnail">
                        <excel-icon></excel-icon>
                    </div>
                    <a
                        href="/files/template-client.xlsx"
                        download
                        class="btn btn-link porto-button"
                        style="margin-right: 30px"
                        >Download Template</a
                    >
                    <div v-if="!hideColumnConfiguration">
                        <button
                            class="btn btn-link"
                            style="margin-top: -6px"
                            @click.prevent="openColumnConfigModal()"
                        >
                            <span class="btn-text">Column Configuration</span>
                        </button>
                    </div>
                </div>
            </div>
            <b-form-group v-if="!hideMergeOption">
                <b-form-checkbox
                    v-model="checked"
                    class="client-check-box"
                    name="check-button"
                    switch
                    @change="onCheck"
                >
                    Incorporate updated Client List names to be Name Screened
                </b-form-checkbox>
            </b-form-group>
            <b-modal
                id="merge-list-popup"
                ref="mergeList"
                title="Merge List"
                hide-header-close
                size="md"
                hide-footer
                modal-class="hide-footer"
                no-close-on-backdrop
                no-close-on-esc
                @hidden="onHidden"
            >
                <merge-list-popup @response="onResponse"></merge-list-popup>
            </b-modal>
            <b-modal
                id="column-config-popup"
                ref="columnConfig"
                title="Column Configuration for Client List"
                hide-header-close
                size="md"
                hide-footer
                modal-class="hide-footer"
                no-close-on-backdrop
                no-close-on-esc
                @hidden="onHidden"
            >
                <column-config-popup
                    @response="columnConfig"
                ></column-config-popup>
            </b-modal>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import excelIcon from '@/components/icons/ExcelIcon.vue'
import mergeListPopup from '@/components/popups/MergeListPopup.vue'
import columnConfigPopup from '@/components/popups/ColumnConfigPopup.vue'
import axios from 'axios'
const apiUrl_data = process.env.VUE_APP_API_URL
const headers = {
    Authorization: `Bearer ${localStorage.getItem('vueauth_token')}`,
}
export default {
    components: {
        excelIcon,
        mergeListPopup,
        columnConfigPopup,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            checked: false,
            uploadFileCss: true,
            blacklist: false,
            progressValue: 0,
            max: 100,
            form: {
                file: null,
            },
            updated_date: null,
            updatedDate: null,
            url: '',
            import_statistics_data: '',
            DowmLoadFileName: '',
            status: '',
            importCustomFile: true,
            acceptFile: '.xlsx,.xls',
            isStopUpdate: false,
            labels: [],
            hideMergeOption: false,
            hideColumnConfiguration: false,
            downloadClientList: true,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'user',
            'dataSegmentId',
            'formBuilderList',
            'loading',
            'showPageLoader',
            'scopes',
        ]),
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.$store.commit('showPageLoader', true)
                this.importCustomData()
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.$store.commit('showPageLoader', true)
        this.importCustomData()

        if (!this.checkPermission(['view-configure-client-list'])) {
            this.hideColumnConfiguration = true
        }

        if (!this.checkPermission(['incorporate-client-list'])) {
            this.hideMergeOption = true
        }

        if (!this.checkPermission(['download-client-list'])) {
            this.downloadClientList = false
        }
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        onCheck(e) {
            if (e == true) {
                this.$refs.mergeList.show()
            }
        },
        onResponse(event) {
            // console.log(event)
            this.checked = event
            this.$refs.mergeList.hide()
        },
        columnConfig(event) {
            this.labels = event
            this.$refs.columnConfig.hide()
        },
        openColumnConfigModal() {
            // if (!this.DowmLoadFileName && this.DowmLoadFileName == '') {
            this.$refs.columnConfig.show()
        },
        showProgress(value) {
            this.progressValue = value
            if (value === 100) {
                this.importCustomData()
            }
        },

        forceFileDownload(response) {
            let d = this.$moment(this.updatedDate).format('DD-MM-YYYY hh:mm:ss')
            d = d.replace(/[:]+/g, '-').replace(/[ ]+/g, '_')

            let fileName =
                'Client_List_' + this.dataSegmentId + '_' + d + '.xlsx'
            const url = window.URL.createObjectURL(new Blob([response.data]))
            // console.log('url', url)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
        },

        startDownload() {
            axios({
                method: 'get',
                url: this.url,
                responseType: 'arraybuffer',
                headers: headers,
            })
                .then((response) => {
                    this.forceFileDownload(response)
                })
                .catch(() => console.log('error occured'))
        },
        async importCustomData() {
            // console.log("custom data api")
            let dataSegmentId = this.dataSegmentId
            if (dataSegmentId) {
                try {
                    let response = await axios.get(
                        apiUrl_data +
                            'screening-data/import-custom-data/' +
                            dataSegmentId,
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${localStorage.getItem(
                                    'vueauth_token'
                                )}`,
                            },
                        }
                    )
                    // <<<<<<< HEAD
                    this.updatedDate = response.data.data.lastUpdatedAt
                    this.updated_date = this.$moment(
                        response.data.data.lastUpdatedAt
                    ).format('DD/MM/YYYY')
                    this.url = response.data.data.fileURL
                    this.DowmLoadFileName = response.data.data.fileName
                    this.status = response.data.data.status
                    // =======

                    //                     if (response.status === 200) {
                    //                         this.updated_date = response.data.data.lastUpdatedAt
                    //                         this.url = response.data.data.fileURL
                    //                         this.DowmLoadFileName = response.data.data.fileName
                    //                         this.status = response.data.data.status
                    //                     }
                    // >>>>>>> 60316e146601dc6fe208b1cb2ab64c446721ba0a
                } catch (e) {
                    this.updated_date = null
                    this.url = ''
                    this.DowmLoadFileName = ''
                    this.status = 'completed'
                }
            }

            this.$store.commit('showPageLoader', false)
        },

        checkPermission(scopes) {
            return !!_.intersection(scopes, this.scopes).length
        },
    }, // End of Component > watch
} // End of export default
</script>
